import { toQueryString } from '@croquiscom/web2app';

export const convertZigzagOriginImage = (imgTags: HTMLImageElement[], target_document = document) => {
  imgTags.forEach((item: HTMLImageElement) => {
    if (item.dataset.origin) {
      const img = target_document.createElement('img');
      const parse = target_document.createElement('a');

      parse.href = item.dataset.src ?? '';
      img.dataset.src = `${parse.origin}/${item.dataset.origin.replace('zigzag://', '')}`;
      img.className = 'lazy';
      img.alt = item.alt;
      img.id = item.id;

      item.parentElement?.replaceChild(img, item);
    }
  });
};

export const convertAnchorHref = (anchorTags: HTMLAnchorElement[]) => {
  anchorTags.forEach((item: HTMLAnchorElement) => {
    if (typeof item.href !== 'string') {
      return;
    }
    if (!item.href?.length || checkIsAnchorHrefStartWordHash(item.href)) {
      return;
    }
    const encodedHref = encodeURIComponent(item.href);

    item.href = `zigzag://open/simple_browser?${toQueryString({
      url: encodedHref,
    })}`;
  });
};

const checkIsAnchorHrefStartWordHash = (href: string) => {
  const link = getAnchorHrefLink(href);
  return link.substring(0, 1) === '#';
};

const getAnchorHrefLink = (href: string) => {
  const pathname_length = window.location.href.length;
  return href.substring(pathname_length);
};
